import con from '../../../connection';
import { ApiGetCompanyUserAffiliations } from './api-get-company-users-detail.response';
import { ApiGetSearchCompanyUsersResponse } from './api-get-company-users.response';

const path = '/company-users';

const companyUsers = (url: string) => (user_id?: string) => ({
  get: (param: {
    words?: string,
    sort_by?: number,
    highlow?: number,
    page?: number,
    id?: string,
  }) => con.get<ApiGetSearchCompanyUsersResponse>(url + path, param),
  getAffiliations: (param: {
    sort_by?: number,
    highlow?: number,
  }) =>
    user_id
      ? con.get<ApiGetCompanyUserAffiliations>(`${url}${path}/${user_id}`, param)
      : (() => { throw new Error('user_id is required');})(),
});

export default companyUsers;